export default (props) => {
  return (
    props.data && (
      <tr className="Table__row">
        {/* 
        {Object.keys(props.data).map((key, i) => ( 
        {}
          <td className={`Table__cell Table__cell_${i==1? "state_highlighted" : "state_default"}`} key={i}>{props.data[key]}</td>
        ))}
        */}

        {props.data.map((item, i) => (
          <td className={`Table__cell Table__cell_${
              i == 1 ? "state_highlighted" : "state_default"}`}
            key={i}>
            {item}
          </td>
        ))}
      </tr>
    )
  );
};
